import React__default from 'react';
import { Shield, Review, Bug } from '@sravni/react-icons';

const IS_ADD_REVIED_PAGE_DATA = [
    {
        icon: React__default.createElement(Shield, null),
        text: 'Внимательно анализируем каждую ситуацию',
    },
    {
        icon: React__default.createElement(Review, null),
        text: 'Ответы от представителя организаций и экспертов Сравни',
    },
];
const IS_NOT_ADD_REVIED_PAGE_DATA = [
    {
        icon: React__default.createElement(Shield, null),
        text: 'Модерация отзывов',
    },
    {
        icon: React__default.createElement(Bug, null),
        text: 'Удаление спама',
    },
    {
        icon: React__default.createElement(Review, null),
        text: 'Ответы от представителей организаций и экспертов Сравни',
    },
];

export { IS_ADD_REVIED_PAGE_DATA, IS_NOT_ADD_REVIED_PAGE_DATA };
//# sourceMappingURL=data.js.map
